module.exports = __webpack_public_path__ + "media/images/athletes/2598-4947b56c59dd33c92309e0d4c9dc7607.png";